import * as z from "zod/v4";

export const getGoogleAdsOAuthURL = {
  name: "getGoogleAdsOAuthURL" as const,
  input: z.null(),
  output: z.object({ url: z.string() }),
};
